<template>
  <el-dialog
    title="新增司机任务"
    :visible="dialogVisible"
    :before-close="handleClose"
    width="600px"
  >
    <el-form ref="deployDriverForm" :rules="rules" :model="deployDriver" size="mini" label-width="90px">
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="司机姓名:">
            <el-input v-model="deployDriver.driverName" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车牌号:">
            <el-input v-model="deployDriver.truckName" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label='起始区域:' prop='startId'>
            <el-cascader
              size='mini'
              ref='startId'
              v-model='deployDriver.startId'
              placeholder='请选择起始区域'
              :options='positionOption'
              :props='props'
              filterable
              @change='handleChange'/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="起始港:">
            <el-select filterable
                       v-model='deployDriver.startPortId'
                       size='mini' clearable
                       placeholder='请选择起始港口' value-key='id' style="width: 100%">
              <el-option v-for='item in startPortList' :key='item.id'
                         :label='item.supplier_name'
                         :value='item.id'></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label='交车区域:' prop='deliveryId'>
            <el-cascader
              size='mini'
              ref='deliveryId'
              v-model='deployDriver.deliveryId'
              placeholder='请选择交车区域'
              :options='positionOption'
              :props='props'
              filterable
              @change='handleChange'/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="交车港:">
            <el-select filterable
                       v-model='deployDriver.deliveryPortId'
                       size='mini' clearable
                       placeholder='请选择交车港口' value-key='id' style="width: 100%">
              <el-option v-for='item in startPortList' :key='item.id'
                         :label='item.supplier_name'
                         :value='item.id'></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="装车时间:" prop="entruckDate">
            <el-date-picker
              v-model="deployDriver.entruckDate"
              type="datetime"
              value-format='yyyy-MM-dd HH:mm:ss'
              placeholder="选择日期" style="width: 100%">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="primary" @click="submitForm">创建装车任务</el-button>
        <el-button @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {applicationAreaInfo} from '@/service/getData';
import {getSelectPort, driverLoadingTask} from '@/service/vehiclelog';

export default {
  data() {
    return {
      dialogVisible: false,
      props: {
        value: 'id',
        label: 'cityName',
        children: 'children',
      },
      deployDriver: {
        basicId: '',
        supplierId: '',//供应商商id
        supplierName: '',//供应商
        driverId: '',//司机id
        driverName: '',//司机姓名
        driverTel: '',//司机电话
        truckId: '',//车牌id
        truckName: '',//车牌号
        entruckDate: '',//装车时
        startId: '',//起始地id
        startPortId: '',//起始港id
        deliveryId: '',//交车区域id
        deliveryPortId: '',//交车港id
      },
      positionOption: [],
      startPortList: [],
      // 首端
      startData: {
        port: '',
        size: 10,
        page: 1,
        total: 0,
      }, // 首端分页数据
      startTable: [],   // 首端表格数据
      // 末端
      endData: {
        delivery: '',
        brandName: '',
        size: 10,
        page: 1,
        total: 0,
      },
      rules: {
        startId: [
          {required: true, message: '请填写起始区域', trigger: 'blur'}
        ],
        deliveryId: [
          {required: true, message: '请填写交车区域', trigger: 'blur'}
        ],
        entruckDate: [{required: true, message: '请填写装车时间', trigger: 'blur'}],
      },
    }
  },
  created() {
    this.getAreaList();
    this.startPosition = JSON.parse(sessionStorage.getItem('areaList'));
  },

  methods: {
    taskPage(row) {
      this.dialogVisible = true;
      this.deployDriver.basicId = row.basicId;
      this.deployDriver.driverName = row.driverName;
      this.deployDriver.driverId = row.driverId;
      this.deployDriver.supplierId = row.supplierId;
      this.deployDriver.supplierName = row.supplierName;
      this.deployDriver.truckName = row.truckName;
      this.deployDriver.truckId = row.truckId;
      this.deployDriver.driverTel=row.driverTel;
    },
    handleClose(done) {
      this.dialogVisible = false;
      this.resetForm();
    },
    resetForm() {
      this.deployDriver.entruckDate = '';
      this.deployDriver.startId = '';
      this.deployDriver.startPortId = '';
      this.deployDriver.deliveryId = '';
      this.deployDriver.deliveryPortId = '';
    },
    async getAreaList() {
      const {
        status,
        message,
        data,
      } = await applicationAreaInfo();
      if (status !== 0) return this.$message.warning(message);
      this.positionOption = data;
    },
    async handleChange(value) {
      this._getSelectPort(value[value.length - 1], 1);
    },
    // 根据区域获取港口
    async _getSelectPort(id, type, index) {
      let port = await getSelectPort(id);
      if (port.status !== 0) return this.$message.error(port.message);
      if (type == 1) {
        this.startPortList = port.data;
      } else {
        this.endPortList[index] = port.data;
        console.log(this.endPortList);
      }
      this.$forceUpdate();
    },
    submitForm() {
      this.$refs.deployDriverForm.validate(async (valid) => {
        if (valid) {
          this.deployDriver.startId=this.deployDriver.startId[this.deployDriver.startId.length-1];
          this.deployDriver.deliveryId=this.deployDriver.deliveryId[this.deployDriver.deliveryId.length-1];
          const res = await driverLoadingTask(this.deployDriver);
          this.handleClose();
          if(res.status===0){
            return this.$message.success(res.message);
            this.$emit('_driverLoadingPageList');
          }else {
            return this.$message.warning(res.message)
          }
        }
      });
    },
  },
}
</script>

<style scoped>

</style>
